import {
    PARTICIPANTS_SAVE_STARTED,
    PARTICIPANTS_SAVE_FINISHED_WITHOUT_COPY,
    CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE,
    CREDIT_APP_UPDATED_ALERT_DISMISSED
} from '../actionTypes/creditAppActionTypes';

export const participantsSaveStarted = () => ({
    type: PARTICIPANTS_SAVE_STARTED
});

export const participantsSaveFinishedWithoutCopy = () => ({
    type: PARTICIPANTS_SAVE_FINISHED_WITHOUT_COPY
});

export const creditAppCopiedByParticipantsSave = (creditApplicationId: string) => ({
    type: CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE,
    payload: { creditApplicationId }
});

export const dismissCreditAppUpdatedAlert = () => ({
    type: CREDIT_APP_UPDATED_ALERT_DISMISSED
});
